import { Link } from "react-router-dom";
import { Clock } from "lucide-react";

export default function BlogCard({ post }) {
  const d = new Date(post.date + "T12:00:00");
  const date = d.toLocaleDateString("pt-BR", { day: "2-digit", month: "short", year: "numeric" });
  return (
    <Link to={`/blog/${post.slug}`} data-testid={`blog-card-${post.slug}`} className="card-rotta group flex flex-col">
      <div className="img-zoom relative aspect-[16/10] overflow-hidden">
        {post.cover_image && <img src={post.cover_image} alt={post.title} loading="lazy" className="w-full h-full object-cover" />}
        <span className="absolute top-4 left-4 pill pill-green">{post.category}</span>
      </div>
      <div className="p-6 md:p-7 flex flex-col flex-1">
        <div className="flex items-center gap-4 text-[11px] tracking-[0.2em] uppercase text-[#7d7d7d]">
          <span>{date}</span>
          <span className="flex items-center gap-1"><Clock size={11} /> {post.read_time}</span>
        </div>
        <h3 className="font-display text-xl md:text-2xl text-white mt-3 group-hover:text-[#C6A762] transition-colors leading-tight">
          {post.title}
        </h3>
        <p className="text-sm text-[#B8B8B8] mt-3 line-clamp-3 leading-relaxed">{post.excerpt}</p>
        <span className="text-[#C6A762] text-xs tracking-[0.2em] uppercase mt-auto pt-5 group-hover:translate-x-1 transition-transform inline-block">
          Ler artigo →
        </span>
      </div>
    </Link>
  );
}
